<template>
  <div class="sell" v-loading.fullscreen.lock="loading">
    <div class="bread">
      <img src="/static/img/fh.png" alt="">
      <ul class="con">
        <li><router-link :to="'/'">首页</router-link>-</li>
        <li class="current">出售账号</li>
      </ul>
    </div>

    <div class="sec">
      <top :title="'活动详情'"></top>
      <div class="con" v-html="act_info.sell_info">
      </div>
    </div>

    <price-form ref="form" :sell_description="config_info.sell_description" :title="'我要出售账号'" :wechatShow="act_info.display_weixin_sell" :wechat="act_info.service_sell" :qqShow="act_info.display_qq_sell" :qq="act_info.qq_sell" :type="3" :sale_extend="act_info.sale_extend*1||0" @submit="submitData"></price-form>

    <div class="sec">
      <top :title="'活动细则'"></top>
      <div class="con" v-html="act_info.sell_rule">
      </div>
    </div>
  </div>
</template>

<script>
import top from '@/components/common/top/top'
import priceForm from '@/components/common/priceform/priceForm'
import { configResource, saleResource } from '@/resource/resource'
import {mapState} from 'vuex'
const ERR_OK = 0

export default {
  name: 'sell',
  data () {
    return {
      act_info: {
        service_sell: ''
      },
      loading: false
    }
  },
  computed: {
    ...mapState(['config_info'])
  },
  created () {
    if (!this.config_info.seInfo) {
       this.getRule()
    } else {
      this.act_info = this.config_info.seInfo
    }
  },
  methods: {
    getRule() {
      this.loading = true
      configResource.config({ config: 'sell_rule,sell_info,sell_form_extend,submit_level_max,submit_level_min,submit_price_max,submit_price_min,qq_sell,display_qq_sell,display_weixin_sell,service_sell,sale_extend' }).then(response => {
        response = response.body
        this.loading = false
        if (response.errcode === ERR_OK) {
          this.config_info.seInfo = response.data
          this.act_info = response.data
        }
      })
    },
    submitData(data) {
      console.log(data)
      this.loading = true
      saleResource.sale(data).then(res => {
        res = res.body
        console.log(res)
        this.loading = false
        if (res.errcode === ERR_OK) {
          this.$alert(res.data, '温馨提示', {
            confirmButtonText: '确定',
            callback: action => {
              this.$refs.form.clearForm()
            }
          })
        }
      })
    }
  },
  components: {
    top,
    priceForm
  }
}
</script>

<style lang="stylus" scoped>
.sell
  width 1000px
  margin 0 auto
  .bread
    display flex
    align-items center
    margin-top 16px
    .con
      display flex
      margin-left 16px
      & > li
        color #626262
        font-size 14px
        & > a
          color #626262
          cursor pointer
      .current
        color $primary
  .sec
    .con
      padding 25px 40px
      color #626262
      font-size 14px
      line-height 22px
      border solid 1px #dcdcdc
      .im
        color rgb(255,0,0)
      .tw
        padding 35px 0
        & > li
          padding-left 105px
          margin-bottom 20px
          display flex
          .label
            color #959595
            font-size 14px
            width 90px
            text-align right
            margin-right 35px
          .text
            color #313131
            font-size 14px
      .bar
        text-align center
        margin-top 40px
        margin-bottom 20px
        .btn
          display inline-block
          height 40px
          text-align center
          background-color #efefef
          border solid 1px #dcdcdc
          width 159px
          color #434343
          font-size 16px
          line-height 40px
          margin-right 50px
          border-radius 2px
          cursor pointer
          outline none
          &:first-child
            background #f59c25
            border solid 1px #f59c25
            color #fff
          &:last-child
            background-color #288cea
            border solid 1px #288cea
            color #fff
</style>



// WEBPACK FOOTER //
// sell.vue?5f194a65